import React from 'react';

/**
 * lot DK2 — boutons d'étape du wizard : barre fixe au-dessus de la barre du bas sous 768 px,
 * bloc normal à partir de 768 px (modèle : `pages/ContactExpressPage.jsx`).
 * `manquants` (liste des champs à remplir) s'affiche au-dessus des boutons, sur une seule ligne.
 */
export const BarreEtape = ({ manquants = null, classeOrdinateur = 'md:mt-4', children }) => (
  <>
    <div className="md:hidden" aria-hidden="true"
         style={{ height: 'calc(96px + env(safe-area-inset-bottom, 0px))' }} />
    <div
      data-testid="wizard-barre-etape"
      className={`fixed md:static inset-x-0 z-30 bg-white border-t border-slate-200 px-4 py-3 md:px-0 md:py-0 md:bg-transparent md:border-0 ${classeOrdinateur}`}
      style={{ bottom: 'calc(58px + env(safe-area-inset-bottom, 0px))' }}
    >
      {manquants && (
        <div className="md:hidden truncate mb-1.5">
          {manquants}
        </div>
      )}
      <div className="flex items-center justify-between gap-3 [&>button:last-child]:flex-1 md:[&>button:last-child]:flex-none">{children}</div>
      {manquants && <div className="hidden md:flex md:justify-end">{manquants}</div>}
    </div>
  </>
);

export default BarreEtape;
